export default __webpack_public_path__ + "static/media/logoRightAligned.02a7178f.png";